export default __webpack_public_path__ + "static/media/dev.806b6f95.svg";